module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("log-history-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "log_history-modal",
    attrs: {
      "width": "980px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v("更新履歴")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body log_history-modal-body ",
    staticStyle: {
      "height": "500px",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cfaa09c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/log-history-modal.vue
// module id = 1045
// module chunks = 0